// extracted by mini-css-extract-plugin
export default {"card":"contactCard_card__7rJAB"};